import { render, staticRenderFns } from "./InviteModal.vue?vue&type=template&id=4b850c07&"
import script from "./InviteModal.vue?vue&type=script&lang=js&"
export * from "./InviteModal.vue?vue&type=script&lang=js&"
import style0 from "./InviteModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports